import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { api, getUser, saveUser, logout, LOGO_URL } from "../api";
import { toast } from "sonner";
import { PauseCircle, XCircle, LogOut } from "lucide-react";

export default function FrozenScreen() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!getUser()) { nav("/login", { replace: true }); return; }
    api.get("/auth/me")
      .then(({ data }) => {
        const st = data.account_status || "active";
        if (st !== "paused" && st !== "deactivation_requested") { nav("/feed", { replace: true }); return; }
        setStatus(st);
        saveUser({ ...getUser(), account_status: st });
      })
      .catch(() => nav("/login", { replace: true }));
  }, []); // eslint-disable-line

  const reactivate = async () => {
    setBusy(true);
    try { await api.post("/auth/reactivate"); toast.success(t("account.reactivated")); saveUser({ ...getUser(), account_status: "active" }); window.location.href = "/feed"; }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); setBusy(false); }
  };
  const deactivate = async () => {
    if (!window.confirm(t("account.confirm_deact"))) return;
    setBusy(true);
    try { await api.post("/auth/deactivate"); setStatus("deactivation_requested"); saveUser({ ...getUser(), account_status: "deactivation_requested" }); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); setBusy(false); }
  };

  const paused = status === "paused";

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="frozen-screen">
      <div className="yp-card p-8 max-w-md w-full text-center space-y-5">
        <img src={LOGO_URL} alt="YouPAM" className="h-8 mx-auto" />
        {status === null ? (
          <div className="text-slate-400 py-8" data-testid="frozen-loading">…</div>
        ) : paused ? (
          <>
            <PauseCircle className="w-14 h-14 mx-auto text-amber-500" strokeWidth={1.5} />
            <h1 className="text-2xl font-bold text-slate-800" data-testid="frozen-paused-title">{t("account.paused_title")}</h1>
            <p className="text-sm text-slate-500" data-testid="frozen-paused-desc">{t("account.paused_desc")}</p>
            <button className="yp-btn yp-btn-primary w-full" onClick={reactivate} disabled={busy} data-testid="frozen-reactivate">{t("account.reactivate")}</button>
            <button className="yp-btn yp-btn-ghost text-red-600 w-full" onClick={deactivate} disabled={busy} data-testid="frozen-deactivate">{t("account.deactivate_now")}</button>
          </>
        ) : (
          <>
            <XCircle className="w-14 h-14 mx-auto text-red-500" strokeWidth={1.5} />
            <h1 className="text-2xl font-bold text-slate-800" data-testid="frozen-deact-title">{t("account.deact_title")}</h1>
            <p className="text-sm text-slate-500" data-testid="frozen-deact-desc">{t("account.deact_desc")}</p>
          </>
        )}
        <button className="yp-btn yp-btn-outline w-full inline-flex items-center justify-center gap-2" onClick={logout} data-testid="frozen-logout">
          <LogOut className="w-4 h-4" /> {t("account.logout")}
        </button>
      </div>
    </div>
  );
}
